var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefinanceCandidates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.53 20.47L19.13 18.07C19.52 17.48 19.75 16.77 19.75 16.01C19.75 13.94 18.07 12.26 16 12.26C13.93 12.26 12.25 13.94 12.25 16.01C12.25 18.08 13.93 19.76 16 19.76C16.76 19.76 17.47 19.53 18.06 19.14L20.46 21.54C20.61 21.69 20.8 21.76 20.99 21.76C21.18 21.76 21.37 21.69 21.52 21.54C21.81 21.25 21.81 20.77 21.52 20.48L21.53 20.47ZM13.75 16C13.75 14.76 14.76 13.75 16 13.75C17.24 13.75 18.25 14.76 18.25 16C18.25 17.24 17.24 18.25 16 18.25C14.76 18.25 13.75 17.24 13.75 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19 8.97007L10.19 4.68007C10.66 4.28007 11.35 4.28007 11.82 4.68007L16.82 8.97007C17.1 9.21007 17.26 9.55007 17.26 9.92007V11.0001C17.26 11.4101 17.6 11.7501 18.01 11.7501C18.42 11.7501 18.76 11.4101 18.76 11.0001V9.92007C18.76 9.12007 18.41 8.35007 17.8 7.83007L12.79 3.55007C11.75 2.66007 10.25 2.66007 9.21 3.55007L4.21 7.83007C3.6 8.35007 3.25 9.11007 3.25 9.92007V16.0001C3.25 17.5201 4.48 18.7501 6 18.7501H11C11.41 18.7501 11.75 18.4101 11.75 18.0001C11.75 17.5901 11.41 17.2501 11 17.2501H6C5.31 17.2501 4.75 16.6901 4.75 16.0001V9.92007C4.75 9.55007 4.91 9.21007 5.19 8.97007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefinanceCandidates);
export default __webpack_public_path__ + "static/media/refinance-candidates.f8d046ba8d01f77c237943f0bdb0592c.svg";
export { ForwardRef as ReactComponent };